const MEMORY_SCOPES = ['global', 'environment', 'installation'];

/**
 * The API serves `variables.memory` as `{}` when the workflow read did not depend on memory,
 * and as a full enumeration carrying every scope bucket when it did (or when the lazy memory
 * route answered). The buckets are therefore the marker for "this workflow's memory is loaded".
 */
const hasEnumeratedWorkflowMemory = (memory) => {
  if (!memory || typeof memory !== 'object') {
    return false;
  }

  return MEMORY_SCOPES.every((scope) => !!memory[scope] && typeof memory[scope] === 'object');
};

export default hasEnumeratedWorkflowMemory;
